export default __webpack_public_path__ + "13d5a4320a4fac629d92064f5d503257.png";